module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUBAMAAABlm+CwAAAAJFBMVEUAAAAXFxcZGRkaGhoaGhoYGBgZGRkaGhoZGRkZGRkZGRkZGRlQIZ4HAAAADHRSTlMAIjNEd4iZqrvM3e4dq2uyAAAAa0lEQVQY02NgYBBxZgACE0cgwaTkNV0JCCqXKCkwaO/e7r0bCLZU797EoM3gNR2krHIJA5DjErXcBQiqlroAOeVwAFIGB4Q5rsgcjgA4x8TFZSuc415evgNJGVsDEieCOHtgHGSHsrjAgQMAn54vwC1SM00AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/date-to.png
// module id = 657
// module chunks = 0